module.exports = __webpack_public_path__ + "static/media/KaTeX_Main-BoldItalic.c7213ceb.woff2";